<template>
  <div class="d-flex justify-content-end">
    <div role="button" class="d-flex border border-primary text-xs">
      <div
        class="px-2 d-flex flex-grow-1 justify-content-center text-center text-nowrap py-1"
        @click="handleInput(true)"
        :class="{'bg-light': !isOn, 'bg-primary text-white': isOn}"
      >
        {{ on }}
      </div>
      <div
        class="d-flex flex-grow-1 justify-content-center text-nowrap text-center py-1 px-2"
        @click="handleInput(false)"
        :class="{'bg-light': isOn, 'bg-primary text-white': !isOn}"
      >
        {{ off }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType  } from 'vue';

export default defineComponent({
  name: 'OnOff',
  props: {
    modelValue: {
      type: String as PropType<'1' | '0'>, // Ensure it accepts string "true" or "false"
      required: true,
    },
    onLabel: {
      type: String,
      default: 'On',
    },
    offLabel: {
      type: String,
      default: 'Off',
    },
  },
  data() {
    return {
      isOn: this.modelValue === '1', // Convert string to boolean
      on: this.onLabel,
      off: this.offLabel,
    };
  },
  methods: {
    handleInput(val: boolean) {
      this.isOn = val;
      this.$emit('update:modelValue', val ? '1' : '0'); // Emit the updated model value as a string
    },
  },
  watch: {
    modelValue(newValue) {
      this.isOn = newValue === '1'; // Update local state when prop changes
    },
  },
  mounted() {
    console.log(this.modelValue);
    console.log(this.isOn);
  },
});
</script>

<style scoped>
/* Add any styles you need here */
</style>

